import { Attachment } from "../../attachments/Attachment"

export interface AggregateLandType {
  id: string | null,
  landCategoryCode: string | null,
  landTypeCode: string | null,
  area: number | null,
  areaSys: number | null,
  description: string | null,
  componentId: string | null
}

export interface AggregateSiteLicense {
  number: string | null,
  name: string | null,
  componentId: string | null
}

export interface AggregateSiteLandAttributeSchema {
  id: string | null,
  landCategoryCode: string | null,
  landTypeCode: string | null,
  area: number | null,
  areaSys: number | null,
  componentId: string | null
}

export interface AggregateSiteLandInfo {
  totalLicensedLandArea: number | null,
  totalLicensedLandAreaSys: number | null,

  totalIntegralLandArea: number | null,
  totalIntegralLandAreaSys: number | null,

  licensedLandUom: string | null,
  unlicensedLandUom: string | null,

  landTypes: AggregateSiteLandAttributeSchema[] | null
}

export interface AggregateSitePond {
  id: string | null,
  pondCategoryCode: string | null,
  pondTypeCode: string | null,
  statusCode: string | null,
  area: number | null,
  areaSys: number | null,
  inletPumpCount: number | null,
  componentId: string | null
}

export interface AggregateSiteWaterExtraction {
  id: string | null,
  locationCode: string | null,
  area: number | null,
  areaSys: number | null,
  perimeter: number | null,
  perimeterSys: number | null,
  waterHalo: number | null,
  waterHaloSys: number | null
  componentId: string | null
}

export interface AggregateSitePondInfo {
  pondTypes: AggregateSitePond[] | null,
  waterExtractions: AggregateSiteWaterExtraction[] | null
  areaUom: string | null,
  perimeterUom: string | null
}

export interface AggregateSiteAnalysisInfo {
  analysisTypeCode: string | null,
  analysisFlag: string,
  analysisReviewedBy: string | null,
  analysisReviewedDate: string | null,
  componentId: string | null
}

export interface AggregateSiteAssessmentInfo {
  licenseOperationTypeCode: string | null,
  licenseActiveFlag: boolean | null,
  licenses: AggregateSiteLicense[] | null,
  surrenderRelinquishLicenseFlag: boolean | null,
  surrenderRelinquishLicenseDate: string | null,
  rehabilitatedLicensedLandFlag: boolean | null,
  unlicensedLandFlag: boolean | null,
  licensedPondFlag: boolean | null,
  belowWaterExtractionFlag: boolean | null,
  attachments: Attachment[] | null,
  land: AggregateSiteLandInfo | null,
  pond: AggregateSitePondInfo | null,
  analysisTypes: AggregateSiteAnalysisInfo[] | null,
  licensedLands1?: AggregateSiteLandAttributeSchema[] | null,
  licensedLands2?: AggregateSiteLandAttributeSchema[] | null,
  licensedLands3?: AggregateSiteLandAttributeSchema[] | null,
  unlicensedLands?: AggregateSiteLandAttributeSchema[] | null
}

// Defaults
export const defaultAggregateSiteLandInfo: AggregateSiteLandInfo = {
  totalLicensedLandArea: null,
  totalLicensedLandAreaSys: null,

  totalIntegralLandArea: null,
  totalIntegralLandAreaSys: null,

  licensedLandUom: null,
  unlicensedLandUom: null,

  landTypes: []
}

export const defaultAggregateSitePondInfo: AggregateSitePondInfo = {
  pondTypes: [],
  waterExtractions: [],
  areaUom: null,
  perimeterUom: null
}

export const defaultAggregateSiteAssessmentInfo: AggregateSiteAssessmentInfo = {
  licenseOperationTypeCode: null,
  licenseActiveFlag: null,
  licenses: [],
  surrenderRelinquishLicenseFlag: null,
  surrenderRelinquishLicenseDate: null,
  rehabilitatedLicensedLandFlag: null,
  unlicensedLandFlag: null,
  licensedPondFlag: null,
  belowWaterExtractionFlag: null,
  attachments: [],
  land: defaultAggregateSiteLandInfo,
  pond: defaultAggregateSitePondInfo,
  analysisTypes: []
}

export const defaultAggregateSiteAnalysisInfo: AggregateSiteAnalysisInfo = {
  analysisTypeCode: null,
  analysisFlag: "X",
  analysisReviewedBy: localStorage.getItem("username") ?? "SYSTEM",
  analysisReviewedDate: (new Date()).toISOString(),
  componentId: null
}

export const defaultAggregateSiteAnalysisTypes: AggregateSiteAnalysisInfo[] = [
  {
    analysisTypeCode: "D",
    analysisFlag: "X",
    analysisReviewedBy: localStorage.getItem("username") ?? "SYSTEM",
    analysisReviewedDate: (new Date()).toISOString(),
    componentId: null
  }, {
    analysisTypeCode: "L",
    analysisFlag: "X",
    analysisReviewedBy: localStorage.getItem("username") ?? "SYSTEM",
    analysisReviewedDate: (new Date()).toISOString(),
    componentId: null
  }, {
    analysisTypeCode: "P",
    analysisFlag: "X",
    analysisReviewedBy: localStorage.getItem("username") ?? "SYSTEM",
    analysisReviewedDate: (new Date()).toISOString(),
    componentId: null
  }, {
    analysisTypeCode: "U",
    analysisFlag: "X",
    analysisReviewedBy: localStorage.getItem("username") ?? "SYSTEM",
    analysisReviewedDate: (new Date()).toISOString(),
    componentId: null
  }
]

export interface ELSAggregateLandCategory {
  "activeFlag": string,
  "code": string,
  "description": string,
  "frenchDescription": string,
  "aggregateLandTypeCode": string[]
}

export interface AggregateOption {
  "code": string,
  "description": string,
  "frenchDescription": string
}

export interface AggregateOptionWithFlag {
  "activeFlag": string,
  "code": string,
  "description": string,
  "frenchDescription": string
}